import Nav from "./Nav";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAddNegativeBill } from "./api";

const Paymentupdate = () => {
  const { state } = useLocation(); // [sid, cid, pname, price, ..., balance]
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const navigate = useNavigate();

  // React Query mutation
  const { mutate, isLoading } = useAddNegativeBill();

  const submitdata = () => {
    if (!amount.trim() || !date.trim()) {
      alert("Please fill all fields before submitting.");
      return;
    }

    const value = {
      sid: state[0],
      cid: state[1],
      amount: amount.trim(),
      pdate: date.trim(),
      balance: state[7],
    };

    mutate(value, {
      onSuccess: () => {
        alert("Payment updated successfully ✅");
        navigate("/sales");
      },
      onError: () => {
        alert("❌ Failed to update payment. Please try again.");
      },
    });
  };

  return (
    <>
      <Nav />
      <div className="container" style={{ marginTop: "8%" }}>
        <div
          className="card shadow p-4"
          style={{ maxWidth: "500px", margin: "0 auto" }}
        >
          <h3 className="text-center text-primary mb-4 fw-bold">
            💰 Update Payment
          </h3>

          {/* Bill No */}
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={state[0]}
              disabled
            />
            <label>Bill No</label>
          </div>

          {/* Customer No */}
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={state[1]}
              disabled
            />
            <label>Customer No</label>
          </div>

          {/* Product */}
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={state[2]}
              disabled
            />
            <label>Product</label>
          </div>

          {/* Price */}
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={state[3]}
              disabled
            />
            <label>Price</label>
          </div>

          {/* Balance */}
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={state[7]}
              disabled
            />
            <label>Balance</label>
          </div>

          {/* Amount */}
          <div className="form-floating mb-3">
            <input
              type="number"
              className="form-control"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter Amount"
            />
            <label>Enter Amount</label>
          </div>

          {/* Payment Date */}
          <div className="form-floating mb-4">
            <input
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <label>Payment Date</label>
          </div>

          {/* Submit Button */}
          <button
            className="btn btn-success w-100 rounded-pill"
            onClick={submitdata}
            disabled={isLoading}
          >
            {isLoading ? "⏳ Saving..." : "✅ Save Payment"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Paymentupdate;
